import { render, staticRenderFns } from "./MaskLoader.vue?vue&type=template&id=28e06adb&scoped=true"
import script from "./MaskLoader.vue?vue&type=script&lang=js"
export * from "./MaskLoader.vue?vue&type=script&lang=js"
import style0 from "./MaskLoader.vue?vue&type=style&index=0&id=28e06adb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e06adb",
  null
  
)

export default component.exports